//------------------------------------------------------------------------
// Anchor Nav Toggle
//------------------------------------------------------------------------
import ExpandToggle from '@threespot/expand-toggle';

export default class AnchorNavToggle {
  constructor(el) {
    this.el = el;
    // Same value as _anchor-nav's $bp-mobile value
    this.mediaQueryList = window.matchMedia('(min-width: 932px)');

    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.destroy();
      } else {
        this.init();
      }
    });

    if (!this.mediaQueryList.matches) {
      this.init();
    }
  }

  init() {
    this.toggle = new ExpandToggle(this.el);
  }


  destroy() {
    if (this.toggle) {
      this.toggle.destroy();
    }
  }
}

const anchorToggle = document.querySelector('[data-expands="AnchorNavigation"]');

if (anchorToggle) {
  new AnchorNavToggle(anchorToggle);
}